const KEY = {
  BACKSPACE: 'Backspace',
  TAB: 'Tab',
  ENTER: 'Enter',
  ESC: 'Escape',
  SPACE: ' ',
  LEFT: 'ArrowLeft',
  UP: 'ArrowUp',
  RIGHT: 'ArrowRight',
  DOWN: 'ArrowDown',
  DELETE: 'Delete',
};

const DELETE_KEY_CODE = 8;

export { KEY, DELETE_KEY_CODE };
